import * as actionTypes from './action-types';
import * as mutationTypes from './mutation-types';
import { supportedLanguages } from '@/translations';

export default {
  namespaced: true,
  state: {
    language: window.localStorage.getItem('locale'),
  },
  mutations: {
    [mutationTypes.SET_LANGUAGE](state, lang) {
      window.localStorage.setItem('locale', lang);
      state.language = lang;
    },
  },
  actions: {
    [actionTypes.SETUP_LANGUAGE]({ commit }, languages) {
      if (typeof languages === 'string') {
        commit(mutationTypes.SET_LANGUAGE, languages);
      } else {
        let language;
        for (let i = 0; i < languages.length; i += 1) {
          const l = languages[i];
          language = supportedLanguages.find(sl => (l.split(new RegExp(sl, 'gi')).length - 1 > 0 ? sl : null));
          if (language) {
            break;
          }
        }
        commit(mutationTypes.SET_LANGUAGE, language);
      }
      return Promise.resolve();
    },
  },
};
